/*
 * Copyright (c) 2022 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import { ENTER_KEY, ENTER_KEYCODE, SPACE_KEY, SPACE_KEYCODE } from '../constants/keyCodes';

//
// This file includes functions that are unique to CareScheduler
//

// called when user keydown on the map marker or location card
export const handleKeyDownSubmission = (e, handler, locationIndex) => {
  const isEnterPressed = e.key === ENTER_KEY || e.keyCode === ENTER_KEYCODE;
  const isSpacePressed = e.key === SPACE_KEY || e.keyCode === SPACE_KEYCODE;
  if (isEnterPressed || isSpacePressed) {
    handler(locationIndex ? locationIndex : undefined);
  }
};

// given a clinic list, returns all locations with data needed to render UI
export const getLocationsFromClinicList = clinics => {
  const locations = [];

  clinics.forEach(clinic => {
    const { id, name, latitude, longitude, address, city, state, zipcode } = clinic.location;
    locations.push({
      id,
      name,
      lat: latitude,
      lng: longitude,
      street: address,
      cityStateZip: `${city}, ${state} ${zipcode}`,
      phoneNumber: clinic.location?.phone
        ? clinic.location?.phone?.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
        : 'Not Provided',
      clinic
    });
  });

  return locations;
};
